import { AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, catchError, debounceTime } from 'rxjs/operators';

export function slugAsyncValidator(
  existingSlugsProvider?: () => Array<string | null | undefined>
): AsyncValidatorFn {
  return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
    const value: string = control.value;

    // Simulate an asynchronous operation with debounceTime
    return of(value).pipe(
      debounceTime(500),
      map(val => {
        const normalizedValue = (val || '').toString().trim();
        const regexPattern = /^[a-zA-Z0-9_-]+$/;

        // Keep required validation in charge of empty values.
        if (!normalizedValue.length) {
          return null;
        }

        if (!regexPattern.test(normalizedValue)) {
          return { invalidSlug: true };
        }

        if (existingSlugsProvider) {
          const existingSlugs = (existingSlugsProvider() || [])
            .filter((slug): slug is string => typeof slug === 'string')
            .map(slug => slug.trim().toLowerCase());

          if (existingSlugs.includes(normalizedValue.toLowerCase())) {
            return { duplicateSlug: true };
          }
        }

        return null;
      }),
      catchError(() => of(null))
    );
  };
}
